export default {
  vote: {
    team: {
      about_title: 'Rules',
      about_con:
        '<p>1. The team member can invite 2 friends to form a team to participate in the lucky draw. </p>\
        <p>2. The gifts are 1 Day VIP, 7 Days VIP , 30 Days VIP, Phone, TV, Decoder, Recharge card.</p>\
        <p>3. Only new devices and accounts which are identified as new users can join the team.</p>\
        <p>4. Each user has a maximum of 10 lucky draw opportunities.</p>\
        <p>5. The activity is valid until Dec. 25, 2019.</p>\
        <p>6. StarTimes ON reserves all the right for final interpretation.</p>',
      my_prizes: 'My Gifts',
      my_won: 'GOT: {0} Days VIP',
      share_btn: 'Share Your Luck',
      invite_tips: 'Invite 2 New Friends to Join and Get Gifts',
      invite_btn: 'TELL FRIENDS TO JOIN',
      invite_btn2: 'SIGN UP & TELL FRIENDS',
      share10_1: 'Soooo Proud of You!',
      share10_2: 'You formed 1-10 Teams!',
      invite_con: 'Join my team and you’ll get VIP and watch it for free.',
      invite_ima: '{0} invites you to join the team to get VIP and gifts.',
      ima_saved: 'Saved to local folder',
      copied: 'copied',
      copy_text: 'COPY',
      search_team: 'Search team',
      search: 'SEARCH',
      search_nores: 'Oops, no results found.',
      join: 'JOIN THE TEAM',
      join_s: 'JOIN',
      reserves: 'VIP will be effective immediately in ME.',
      form_late: "Oops,  you're a little late，form a new team.",
      form_newbtn: 'FORM A NEW TEAM',
      form_succ: "Congrats! You've successfully teamed up and got 1 chance to get VIP and gift!",
      form_noform: "Sorry, you haven't formed the team yet. Share it with your friends to join!",
      boardcast_con: '{0} has got {1}!',
      invite_tip: '{0} <br/>invite you to join the team and get gifts!',
      full_team: 'Sorry, the team has enough members.',
      follow_team: 'The following teams still have one position, join now!',
      invite_won: '{0} people have already got VIP.',
      team_id: 'Team ID',
      invite_infotit: 'Watch Live TV and Enjoy Best VOD Contents.',
      joinpop_newuser: 'Just waiting for you, Click to Join.',
      change: 'Change',
      joinpop_olduser: 'Oh, my old friend. Only new user can join team. You can also invite friends and form a new team to get gifts.',
      download_tip: 'Start downloading apk now? (12M)',
      show_lucky: 'SHOW THEM HOW LUCKY I AM',
      download_join: 'DOWNLOAD TO JOIN NOW',
      have_team: 'You can only own one team at the same time.',
      input_error: 'Please enter a valid Team ID.',
      network_error: 'Network error.',
      tips: `Tips: <br/>The VIP gift you got will be effective from today.`,
      no_awards: 'No gift yet.',
      draw_title: 'Draw your gift',
      draw_button: 'DRAW',
      draw_none: 'Thank you, it will be better next time.',
      my_won_one: 'GOT: {0} Day VIP',
      facebook: 'Facebook',
      whatsapp: 'Whatsapp',
      xender: 'Xender',
      download: 'Save image',
      copy: 'Copy link',
      download_apk: 'DOWNLOAD NOW',

      //add
      shareTitle: 'Make A Team to Win Free VIPS',
      shareText: 'Join my team and send you VIP to watch it all for free',
      countdownTitle: 'Remaining',
      enterID: 'enter team ID',
      welcome: 'Welcome',
      newuser_popup: 'if you were invited by friends',
      or: 'or',

      //no need
      prize_step: 'Follow the steps below to get gift now.'
    },
    euro: {
      rules: 'Prizes',
      rule_title: `<p style="color:#F3953A;font-weight:bold">Rules and Prizes</p>`,
      rule_text: `<p>1.Activity time:</p>
      <p>The activity is from June 7th to July 13th, and we will do two predictions:</p>
      <p>a.June 7th to June 19th, predicting where each team in each of the six groups will finish and the four best third-placed teams who will go to the knockout stage;</p>
      <p>b.June 24th to July 6th, predicting which team win into the next round and which teamwill get the crown in the final.</p>
      <p>2.Activity prizes:</p>
      <p>Prediction Award:</p>
      <p>1-year free Max package.</p>
      <p>Lucky Award:</p>
      <p>1-month free Max package</p>
      <p>1-week free Max package</p>
      <p>3-days free Max package</p>
      <p>1-day free Max package</p>
      <p>3.Activity Rules:</p>
      <p>a.All need to register and log in before participating the prediction activity;</p>
      <p>b.Only if you link your DVB card with OTT account, then you can have a chance to win Prediction Award.</p>
      <p>c.Participate to get points. In the group stage, you will get 2 points every time you correctly predict the position of one team, and you will get 1 point for each team in the best 4 third-placed teams, a total of 52 points. In the knockout stage, you need to predict before the game starts, otherwise you won’t get points of this game. You willget 3 points for each team in round of 16 and quarter-finals, and you will get 4 points for each team in semi-finals and final match, a total of 48 points. If you participate in these two predictions, you have chance to get 100 points. Finally, you will get lucky awards according to your points.</p>
      <p>4.Activity awards:</p>
      <p>a.Prediction Award: </p>
      <p>Winners of prediction award will be randomly selected from people who predict the most accurately on the June 25th and July 13th. The results will be displayed on the Facebook and prediction page.</p>
      <p>b.Lucky Award: </p>
      <p>Points: >=90, 1 months Max package</p>
      <p>Points: <90 and >=70, 1 week Max package</p>
      <p>Points: <70 and >=50, 3 days Max package</p>
      <p>Points: <50 and > =30, 1 day Max package</p>
      <p>During the event, if you log in for more than 10 days, you will surely win a lucky award.</p>
      <p>These prizes will be released to the winners’ account in the 3 to 5 working days after the end of event.</p>
      <p>5.Additional information</p>
      <p>a.You need to provide an exact phone number and keep it unblocked. The phone number is an important certificate for awarding;</p>
      <p>b.Malicious registration is prohibited. If any malicious registration is found, the organizer has the right to cancel the qualification of the event and reserve the right to pursue their legal responsibility;</p>
      <p>c.The deadline for redemption is July 20th, if we fail to get in touch with you before the deadline, it will be considered invalid.</p>
      <p>d.The organizer reserves the right to change these terms and reserves the right to final interpretation.</p>`,
      rule_text_ug: `<p>1.Activity time:</p>
      <p>The activity is from June 7th to July 13th, and we will do two predictions:
      a.June 7th to June 19th, predicting where each team in each of the six groups will finish and the four best third-placed teams who will go to the knockout stage;</p>
      <p>b.June 24th to July 6th, predicting which team win into the next round and which teamwill get the crown in the final.</p>
      <p>Besides these two predictions, there will be four lotteries for all users who participate in the prediction activity and meet the conditions, on the June 18th, June 25th, July 1st, July 11th.</p>
      <p>2.Activity prizes:</p>
      <p>Prediction Award:</p>
      <p>First Prize:   10M UGX (Individual prize）</p>
      <p>Second Prize:   Senke Motorcycle (3 highest score)</p>
      <p>Third Prize:   StarTimes 32 inch TV</p>
      <p>Fourth Prize:   Euro 2020 Football</p>
      <p>Lottery Award:</p>
      <p>First Prize:   Senke Motorcycle (2 lucky customers)</p>
      <p>Second Prize:   StarTimes 32 inch TV</p>
      <p>Third Prize:   Euro 2020 Football</p>
      <p>Fourth Prize:   Euro 2020 Jersey</p>
      <p>Lucky Award:</p>
      <p>  1-month free Max package</p>
      <p>  1-week free Max package</p>
      <p>  3-days free Max package</p>
      <p>  1-day free Max package</p>
      <p>3.Activity Rules:</p>
      <p>a.All need to register and log in before participating the prediction activity;</p>
      <p>b.Only if you link your DVB card with OTT account, meet at least one of the following conditions during this event period from June 1st to July 11th and before the draw, then you can have a chance to win physical prizes: Prediction Award and Lottery Award.</p>
      <p>i.Subscribe UGX 20,000/- on Antenna Decoder for Basic Bouquet Customers, If onNOVA Antenna, Upgrade your bouquet to Basic then Subscribe the UGX 20,000/-;</p>
      <p>ii.Subscribe Classic monthly Bouquet at least once on Antenna decoder;</p>
      <p>iii.Subscribe Smart monthly Bouquet at least once on Antenna decoder;</p>
      <p>iv.Subscribe Super monthly Bouquet at least once on Antenna decoder;</p>
      <p>v.Buy a new decoder and activate.</p>
      <p>c.Participate to get points. In the group stage, you will get 2 points every time you correctly predict the position of one team, and you will get 1 point for each team in the best 4 third-placed teams, a total of 52 points. In the knockout stage, you need to predict before the game starts, otherwise you won’t get points of this game. You willget 3 points for each team in round of 16 and quarter-finals, and you will get 4 points for each team in semi-finals and final match, a total of 48 points. If you participate in these two predictions, you have chance to get 100 points. Finally, you will get lucky awards according to your points.</p>
      <p>4.Activity awards:</p>
      <p>a.Prediction Award: </p>
      <p>Winners of prediction award will be randomly selected from people who predict the most accurately on the June 25th and July 13th. The results will be displayed on the Facebook and StarTimes ON prediction page and Sanyuka TV.</p>
      <p>b.Lottery Award: </p>
      <p>Winners are randomly selected from all those who meet the conditions for participation on the June 18th, June 25th, July 1st, July 11th.</p>
      <p>During the event, if you log in for more than 10 days, you will surely win lucky award. The results will be displayed on the Facebook, StarTimes ON page and Sanyuka TV.</p>
      <p>c.Lucky Award: </p>
      <p>Points: >=90, 1 months Max package</p>
      <p>Points: <90 and >=70, 1 week Max package</p>
      <p>Points: <70 and >=50, 3 days Max package</p>
      <p>Points: <50 and >=30, 1 day Max package</p>
      <p>During the event, if you log in for more than 10 days, you will surely win lucky award.</p>
      <p>For prediction award and lottery award, those physical award, winners need to contact the organizer. After the necessary verification, awards will be awarded.</p>
      <p>For Lucky award, it will be released to the winners’ account in the 3 to 5 working days after the end of event.</p>
      <p>5.Additional information</p>
      <p>a.You need to provide an exact phone number and keep it unblocked. The phone number is an important certificate for awarding;</p>
      <p>b.Malicious registration is prohibited. If any malicious registration is found, the organizer has the right to cancel the qualification of the event and reserve the right to pursue their legal responsibility;</p>
      <p>c.The deadline for redemption is July 20th, if we fail to get in touch with you before the deadline, it will be considered invalid.</p>
      <p>d.The organizer reserves the right to change these terms and conditions and the right to final interpretation.</p>`,
      rule_text_gh: `<p>Submit your prediction for the final ranking of each group, and the four best third-place teams <strong>by June 19</strong></p>
      <p>AND</p>
      <p>Your prediction for the winner of each knockout stage game, all the way to the Final, <strong>by the beginning of each game</strong></p>
      <p>for a chance to win these AMAZING prizes!</p>
      <p><strong><u>The Prize</u></strong></p>
      <p>You will get points for every correct prediction. If you are among the BEST predictors, you will be entered into a draw for one of the three following prizes!</p>
      <p>Techno Phantom 10</p>
      <p>Techno Camon 17</p>
      <p>Techno Spark 7</p>
      <p>Winners are announced on StarTimes Facebook and Instagram page! Subscribe to them today to stay updated!</p>
      <p><strong><u>Remember!</u></strong></p>
      <p>Only active users of StarTimes decoders or VIP users of the APP are eligible to participate. Youneed to provide this information and a phone number when submitting your prediction and for receiving the prize.</p>
      <p>The deadline to redeem your prize is July 20. If we cannot get in touch with you then，your prize will be invalidated.</p>
      <p>*StarTimes reserves the right to change these terms and conditions at any time without prior notice.</p>`,
      share: 'Share',
      share_title: 'EURO2020 Prediction',
      share_text: 'I am watching Euro2020 on StartimesON, and I can win prizes by guessing the result of the match. Come and join me now!',
      confirm: 'Confirm',
      cancel: 'Cancel',
      group: 'Group',
      third_teams_title: 'Predict the four best third-placed teams',
      confirm_submit_info: 'Are you sure about your predictions？',
      prize_title: 'LIST OF PRIZES',
      result_tips_success: 'You have successfully submitted your predictions!',
      result_tips_end: 'This prediction has ended, please participate in the next one.',
      sign_in: 'Sign in',
      sign_in_info: 'Sign in to start your prediction!',
      vip_tips:
        'Please ensure that you have purchased a membership package or linked your DVB decoder, which is a prerequisite for obtaining prizes:',
      dvb_link_decode: 'LINK DECODER',
      ott_get_vip: 'GET VIP',
      phone_tips: 'In order to inform you when you win the prize, please fill in the correct contact information:',
      phone_error_info: 'Please enter a valid phone number!',
      phone_placeholder: 'Please enter your phone number',
      phone_confirm_info:
        'The phone number is your only proof of receiving the prize. Please check it carefully and you cannot modify it after submission.',
      network_error: 'Poor network, please check your network!',
      change_rank_tip: 'Click the up and down arrows to rank the teams',
      no_finish_tip: 'You need to choose the 4 best third-placed teams to complete your prediction!',

      // 二期补充
      next: 'NEXT',
      back: 'BACK',
      no_finish_tip2: 'Please complete all predictions before proceeding to the next round',
      no_participate: 'You did not participate in the last event.',
      no_prize: "Unfortunately, you didn't win the prize last time!",
      get_prize: 'Congratulations to you for getting ',
      get_point1: 'You have earned ',
      get_point2: ' points, predict to get more!',
      submit_success: 'You have successfully submitted your predictions! Stay tuned for the lucky draw results!',
      swipe_tip: 'Swipe to see all',
      loading: 'Loading...'
    },
    africa: {
      rule: 'RULE',
      share: 'SHARE',
      rule_title: `<p style="color:#CB043F;font-weight:bold;">RULE</p>`,
      rule_text: `<p>1. Predict the game on the day. It is impossible to predict after the start of the game.</p><p>2. After each prediction, there is a chance to participate in the lottery.</p><p>3. If you guess all the correct scores, you get 5 points.</p><p>If you guessed the score of one game correctly and the win-loss relationship between the two is correct, you get 3 points.</p><p>If you only predict the score of one team correctly, you get 2 points.</p><p>If you only predict a win - Loss relationship (including a tie), but fail on correct scores you get 1 point.</p><p>Instruction:</p><p>Only logged-in users are eligible to participate in predictions and lottery, as well as to participate in the ranking of points.</p>`,
      prize_details: 'PRIZE DETAILS',
      prize_details_text1: 'Users with the highest points will be rewarded motorcycles',
      prize_details_text2: 'Users with the second and the third will be rewarded MAXVIP for life',
      prize_details_text3: 'Users with the fourth and the fifth will be rewarded three-year membership',
      prize_details_text4: 'Users with the sixth to the tenth will be rewarded one-year members',
      fixture: 'FIXTURE',
      africa_rank: 'POINTS RANKING',
      points: 'Points: ',
      replay: 'REPLAY',
      predict: 'PREDICT',
      predicted: 'PREDICTED',
      live: 'LIVE',
      over: 'OVER',
      my_points: 'My Points: ',
      my_ranking: 'My Ranking: ',
      lottery_title: 'LOTTERY AREA',
      lottery_des:
        'Every time a prediction is made, one chance to draw a lottery will be given, and VIP or LINK decoder users will get one more chance',
      lottery_left: 'Remaining number of draws: ',
      my_prize: 'MY PRIZE',
      start: 'START',
      has_got: 'has got',
      more_vote_title: 'HOW TO GET MORE DRAWS',
      predict_btn: 'PREDICT',
      predict_des: '1. Make a prediction',
      ott_btn: 'BUY VIP',
      ott_des: '2. StarTimesON VIP benefits',
      dvb_btn: 'LINK',
      dvb_des: '3. StarTimes DVB  benefits',
      buy_btn: 'BUY',
      buy_des: '4. Purchase any amount of VIP or recharge once',
      share_btn: 'SHARE',
      share_des: '5. Share with new users to participate in activities',
      lottery: 'Lottery',
      video_title: 'HIGHLIGHTS',
      confirm: 'CONFIRM',
      lottery_no_left:
        'With each prediction comes a chance for more lucky draws! Buying VIP and LINK your decoder to increase your chance of winning!',
      predict_success: 'Submit your prediction for a chance to win big! Buy a VIP, link your decoder or share to increase your chance of winning! ',
      lottery_success: 'Congrats for winning ',
      lottery_sorry: 'Thank you for participation!',
      lottery_again: 'Congrats for receiving a chance to win!',
      no_left: ' Your lottery has been used up!',
      to_signin: 'Participate in the event after logging in! Participate in the event to win big prizes!',
      lottery_btn: 'DRAW',
      add_btn: 'ADD CHANCE',
      sign_btn: 'SIGN IN',
      continue_btn: 'CONTINUE',
      // 补充
      before_start: 'Activity has not started!',
      after_end: 'Activity has ended!',
      ok: 'OK',
      loading: 'Loading…',
      download: 'DOWNLOAD'
    },
    appvote: {
      select_one: 'Select one',
      select_more: 'Select one or more',
      pre_vote: 'Post-Selection Voting',
      vote: 'Vote Now',
      download_btn: 'Download Now',
      vote_success: 'Voting was successful! Download Startimes ON to see the results and more great videos to come!'
    },
    bssregister: {
      rule_btn: 'RULES',
      rule: '<p style="color:#55A081;font-weight:bold;">RULES</p>',
      rule_text: `\nOnline Audition\n\n1. Time of online audition: 9 Nov, 2024- 22 Dec, 2024\n\n2. Conditions\n\nⅠ.Record yourself singing the whole song\n\nⅡ.Record yourself immediately, do not edit or modify anything.\n\nⅢ.The song should carry all the sound characteristics that show the singer's feelings\n\nⅣ.The participant has to record his/her appearance. Fake singing is not allowed.\n\n3. How to register\n\nI. Online registration- StarTimes ON APP\n\nParticipants should record themselves singing the whole song, then upload their videos on YouTube/Tik Tok/Instagram (Copy link); Then download and open STARTIMES ON APP, enter the BSS interview section; fill in your important information, put your YouTube link while singing; submit, then wait for your work to be uploaded.\n\nII.Another way to register-Instagram\n\nRecord a video of yourself singing and then post it on Instagram, and put the hashtag #bssonlineaudition2024 and finally tag @startimestz *IMPORTANT: All the works of online participants will be reviewed for 48 hours after uploading, and the results will be placed in the next selections\n\n4.Rules\n\nAfter the publications, voting will officially open on StarTimes ON APP “Online Audition Election Voting Channel”. Until the end, 1~5 winners will qualify to enter the knockout stage of the competition.\n\nOffline Audition\n\n4. Time and place\n\nBSS interview dates\n\n• Nov 09 - 10 : Arusha 🇹🇿\n\n• Nov 16 - 17 : Mwanza 🇹🇿\n\n• Nov 23 - 24 : Kampala 🇺🇬\n\n• Nov 29 - 30 : Nairobi 🇰🇪\n\n• Dec 07 - 08 : Babati 🇹🇿\n\n• Dec 13 - 15 : Dar es Salaam 🇹🇿\n\n5. Method of interview\n\nCandidates who will participate in the offline interview are advised to go to the above mentioned locations due to the interview time.\n\n6. Selection rules\n\nThere are 5 opportunities for non-internet interviews in each interview (except Dar es Salaam), 4 expert judges will interview the participants with YES or NO. Participants who pass the interview that day will participate again in the second interview the next day in order to select those who will move forward in the competition.\n\n7. Others\n\nDue to the presence of many people who appear during the interview, the preparation of the session also takes place on the day of the interview. You are advised to arrive early at the interview location and follow the instructions. \n\n8. All Rights are Reserved by StarTimes `,
      loading: 'Loading...',
      name: 'NAME',
      sex: 'GENDER',
      male: 'Male',
      female: 'Female',
      select_placeholder: 'Please enter',
      birthday: 'DATE OF BIRTH',
      year: 'Year',
      month: 'Month',
      day: 'Day',
      number: 'PHONE NUMBER',
      number_error: 'Please enter correct phone number',
      country: 'COUNTRY',
      city: 'CURRENT RESIDENCE',
      profession: 'OCCUPATION',
      link: 'VIDEO LINK',
      link_placeholder: 'Video links for Tiktok/Instagram/Youtube',
      howto_getlink: 'HOW TO GET THE VIDEO LINK?',
      end_text: 'Sorry, registration is closed',
      offway_title: 'OFF-LINE REGISTRATION',
      offway_text: `Auditions for Bongo Star Search season 15 will be held in Arusha, Mwanza, Kampala Uganda, Nairobi Kenya, Babati and Dar es Salaam.<br/>It will start in Arusha on 09/11/2024. Get excited about this great opportunity. Regarding how to join the competition, please click on the link. Don't forget there are more opportunities waiting for you!`,
      success_title: 'Registration successful',
      success_text:
        'If approved, we will review your video and your video will be displayed on the APP within 48 hours. Don’t forget you’ve signed up!',
      ok: 'OK',
      share: 'SHARE',
      share_title: 'You are the next bingo star',
      share_text: 'Record a video of yourself singing, register NOW! This opportunity is yours.',
      ke: 'Kenya',
      ug: 'Uganda',
      tz: 'Tanzania',
      profession_list: [
        'Sales/Marketing',
        'Accounting/Management',
        'Projects/Quality',
        'Information Technology/Network/Telecommunications',
        'Non-current Assets/Construction',
        'Finance/Funds',
        'Transportation/Logistics',
        'Manufacturing/Production',
        'Information Technology Equipment/Art/Craftsmanship',
        'Consulting/Legal/Education',
        'Service Sector',
        'Energy/Environment',
        'Agriculture',
        'Scientific Research',
        'Temporary Work/On-the-job Training/Others'
      ],
      title1: 'PROCESS OF JOINING ONLINE',
      title2: 'OTHER REGISTRATION METHODS',
      title3: 'HIGHLIGHTS',
      submit: 'SUBMIT'
    },
    bssvote: {
      rule_btn: 'RULES',
      rule: '<p style="color:#55A081;font-weight:bold;">RULES</p>',
      rule_text: `\nFrom Nov 9 to Dec 22, you have 5 votes every day after logging in. Votes will be totaled and valid until the end of the activity.\n\nYou can vote for any contestant you like!\n\nShare the link to your friends and ask them to download the StarTimes ON App to get more votes! You will get 5 more votes for each new user. The more new users you bring in, the more votes you get! And also, if you connect your Decoder with the App, or if you are a VIP of the App, you will get 20 more votes!\n\nEvery time you vote, you will get one chance to get StarTimes Decoder, Dish, or Max VIP of the Month for StarTimes ON and Coupons.\n\nPrizes will be awarded the next business day in Me-> My Coupons.\n\nThe top 10 candidates with the most votes will be able to enter the final interview, and finally 5-10 candidates will be selected by the teacher to participate in 2024BSS S15.`,
      new_info: 'Participate in the vote to get more votes',
      way_link: 'HOW TO GET MORE VOTES?',
      vote_left: 'Number of remaining votes: ',
      vote: 'VOTE',
      more_singer: 'VIEW ALL PARTICIPANTS',
      tosign: 'SIGN UP',
      tofinish: 'COMPLETE IT',
      finished: 'COMPLETED',
      invite: 'INVITE',
      invite_text: 'Successfully invited friends: ',
      info: `Every time you vote,<br />you will have a chance to win prizes.`,
      lottery_left: 'REMAINING DRAWS:',
      tip: 'FIND PRIZE ON ME -> MY COUPON',
      vote_title: 'VOTER FOR YOUR CHOICE',
      close: 'CLOSE',
      share_title: 'Beyond Borders Si Mchezooo!',
      share_text:
        'The choice is yours! Choose the candidate you like and help him participate in the Bongo Star Search 2024 participant search stage.',
      ok: 'OK',
      share: 'SHARE',
      cancel: 'CANCEL',
      before_start: 'Voting starts on November 9th, so stay tuned!',
      after_end: 'Sorry, voting is closed',
      voteleft0: 'Sorry, your remaining votes are 0',
      get_more: 'HOW TO GET MORE VOTES?',
      nomore: 'The vote failed. Not enough votes',
      fail1: 'success! Share with friends to get more votes',
      fail2: 'success! You will get prizes by participating in the game',
      sign_tip: 'Go and participate in lucky draw',
      nomore_vote: 'Go vote for a chance to win good to draw. Every time you vote, you will have a chance to win prizes.',
      win_morevote: 'Congratulations! You got {0} votes again!',
      win_again: 'Congratulations! You have one more chance!',
      win_normal: 'Congratulations! You got {0}! Rewards will be issued on the second business day of My Me->Coupon.',
      sorry: 'Thanks for participation',
      getott: 'LIPIA VIP',
      getdvb: 'CONNECT DIKODA&APP',
      sign: 'REGISTER',
      toinvite: 'INVITE FRIENDS',
      title1: 'VOTE FOR THE CONTESTANT YOU SUPPORT',
      title2: 'HOW TO GET MORE VOTES?',
      title3: 'LUCK DRAW',
      title4: 'MORE VIDEOS'
    },
    bssresult: {
      rule_btn: 'RULES',
      share_btn: 'SHARE',
      rule_title: '<p style="color:#55A081;font-weight:bold;">Rules for voting</p>',
      rule_text:
        '\n1. From Nov 9 to Dec 22, you have 5 votes every day after logging in. Votes will be totaled and valid until the end of the transaction.\n\n2. You can vote for any contestant you like!\n\n3. Give the link to your friends and ask them to download the StarTimes ON App to get more votes! You will get 5 more votes for each new user. The more new users you bring in, the more votes you get! And also, if you connect your Decoder with the App, or if you are a VIP of the App, you will get 20 more votes!\n\n4. Every time you vote, you will get one chance to get StarTimes Decoder, Dish, or Max VIP of the Month for StarTimes ON and Coupons.\n\n5. Prizes will be awarded the next business day in Me-> My Coupons.\n\n6. The top 10 candidates with the most votes will be able to enter the final interview, and finally 5-10 candidates will be selected by the teacher to participate in 2024BSS S15.',
      share_title: 'You are the next Bongo star.',
      share_text:
        'The choice is yours! Choose the candidate you like and help him participate in the Bongo Star Search 2024 participant search stage.',
      ok: 'OK',
      highlights: 'MORE VIDEOS'
    },
    bsspopular: {
      rule_btn: 'RULES',
      share_btn: 'SHARE',
      rule_title: '<p style="color:#55A081;font-weight:bold;">Voting rules</p>',
      rule_text:
        '<p>1.During the event, you have 5 votes every day after logging in. The votes will be accumulated and valid until the end of the event.</p><p>2.You can vote for any participant you like!</p><p>3.Share the link with your friends and have them download the StarTimes ON App to get more votes! You will get 5 more votes for each new user. The more new users you bring, the more votes you get! And also if you link your Dikoda to the App, or become a VIP of the App, you will get 20 more votes!</p><p>4.Every time you vote, you will increase your chances of winning prizes.</p><p>5.Each user can get up to 50 votes per day by sharing the link with new users, and the number of votes received during the event will not exceed 1,000.</p><p>6.Prizes will be awarded the next day. Click "Me"->" My Coupons"and you will see your prizes.</p>',
      share_title: 'StarTimes ON',
      share_text: 'Bongo Star Search Season 15 Voting window for the most popular participants!!',
      ok: 'OK',
      cancel: 'CANCEL',
      to_more_vote: 'HOW TO GET MORE VOTES?',
      vote_left: 'Number of remaining votes:',
      vote: 'VOTE',
      tosign: 'Sign Up',
      tofinish: 'COMPLETE IT',
      finished: 'COMPLETED',
      invite: 'INVITE',
      invite_text: 'SUCCESSFULLY INVITE FRIENDS:',
      info: 'Every time you vote,you will have a chance to win prizes.',
      lottery_left: 'REMAINING DRAWS:',
      tip1: 'Coupons and prizes can be viewed here, click “ME” then “my coupon”',
      tip2: 'Users who win prizes,contact us to collect them from designated stores',
      vote_title: 'VOTE FOR YOUR FAVORITE',
      close: 'CANCEL',
      before_after: 'Activity has not started!',
      after_end: 'Activity is over!',
      voteleft0: 'Sorry, your remaining vote is 0.',
      nomore: 'The vote has failed. There are not enough votes left.',
      fail1: 'Successful! Involve friends to get more votes.',
      fail2: "Successful! You've got a chance to win a prize by going through the game on this page.",
      sign_tip: 'Please register to start the lucky draw.',
      nomore_vote: 'Go vote to win a lucky draw. Every time you vote, you have a chance to win a prize.',
      win_normal: 'Congratulations! You got {0}! Prizes will be awarded the next day. Click "Me"->" My Coupons"and you will see your prizes.',
      sorry: 'Thanks for participation.',
      has_got: 'has got'
    }
  },
  native: {
    guide: {
      channellistbottom: 'No more channels',
      channelslist: ' channels',
      channellist: ' channel',
      searchbox: 'Channel name or code',
      searchresults: ' search results have been found for ',
      search1result: '1 search result has been found for ',
      search0result: 'No search results have been found for ',
      noepg: 'No available EPG for today',
      tvguide: 'Guide',
      network_error: 'Network error.'
    },
    exchangecode: {
      code: 'Code:',
      sure: 'Sure',
      tips: 'Congratulations! ! ! Fill in the redemption code to redeem the reward! ! !',
      no_sign: 'Only new registered users can participate in this activity. So register now! ! !',
      old_sign: 'Only new registered users can participate in this activity! ! !',
      error_code: 'This code is invalid, please check and re-fill ! ! !',
      repeat_code: 'You have already participated in this activity and cannot participate again! ! !',
      repeat_device: 'This device has already participated in the activity and cannot participate again! ! !',
      h5_call: 'The redemption code can only be used in the app, please download and install the app ! ! !',
      success_tip1: 'Congratulations! ! ! You get ',
      success_tip2: ', go watch the video now! ! !',
      server_error: 'Server error!'
    },
    multipledevices: {
      share_text: 'Hey there, friend! I’m going to share my Startimes ON account with you so we can enjoy awesome shows and games together!'
    }
  },
  template: {
    dvbActivity: {
      startimes_on_app: 'STARTIMES ON APP',
      download: 'DOWNLOAD',
      rule: 'RULE',
      rule_text:
        '<p>1. A smart card can be linked to a maximum of three Starimes ON accounts, which will allow you to enjoy premium content for free.</p><p>2. Enter your smart card number and the last six digits of your serial number to verify that you have linked to the smart card by entering your mobile phone number.</p><p>3. If the mobile phone number you enter is not registered, you can follow the instructions to download the app and complete registration before linking your card.</p><p>4. If you have already registered your mobile phone number, you can link to the smart card directly</p>',
      smart_card: 'SMART CARD ID',
      decoder: 'Decoder ID(Last six digits)',
      err_code12: 'Invalid card number',
      err_code13: 'Smart Card ID and Decoder ID no match',
      err_code21: 'LINKING FAILED. Card is linked beyond the limitation (maximum of three users per card)',
      next: 'NEXT',

      limit_tip1: 'This card can be linked to a total of 3 user accounts. Currently linked to ',
      limit_tip2: ' accounts and can be linked to ',
      limit_tip3: ' accounts.',
      wait_bind: 'Waiting bind...',
      phone_number: 'Phone Number:',
      err_code1: 'Card linked successfully',
      err_code5: 'Wrong mobile number',
      err_code15: 'User has already linked this card',
      bind: 'Activate',

      off: 'OFF',
      for_order_above: 'For order above ',
      coupon: 'coupon',
      recharge: 'Recharge',
      congratultions: 'Congratultions!',
      got_right: 'Got Startimes ON right!',
      right_title1: 'Family Plan',
      right_content1: 'One Decoder Can Be Added Up To 3 Family Members In Your Household',
      right_title2: 'Free Live Channel Streaming',
      right_content2: 'Watch All Channels Free Under Your Active Bouquet',
      right_title3: 'Free VOD Contents',
      right_content3: 'Enjoy All Free Without Another Subscription & At Least Super/Classic',
      benefits: 'Activate benefits now',
      highlights: 'Highlights',

      ok: 'OK',
      cancel: 'Cancel',
      server_error: 'Server error!',
      before_start: 'Activity has not started!',
      after_end: 'Activity has ended!'
    },
    vote: {
      share: 'SHARE',
      vote_left: 'Remaining Votes:',
      vote: 'VOTE',
      sign_tip: 'Login ',
      ott_tip: 'Login as StarTimes On Subscriber ',
      dvb_tip: 'Login if StarTimes On Account has Linked with Decoder ',
      pay_tip: 'Subscribe StarTimes On ',
      pay_dvb_tip: 'Subscribe StarTimes Decoder via StarTimes On ',
      comment_tip: 'Successfully Post a Comment ',
      pay_mtn_tip: 'Subscribe ${0} MTN CallerTunez ',
      share_tip: 'Share',
      to_finish: 'Finish',
      finished: 'Finished',
      to_buy: 'Subscribe',
      to_share: 'Share',
      more_vote: 'GET MORE VOTES',
      how_many_vote: 'How many votes do you want to give?',
      ok: 'OK',
      cancel: 'Cancel',
      before_start: 'Activity has not started!',
      after_end: 'Activity has ended!',
      server_error: 'Server error!',
      vote_success: 'Voting success! ',
      vote_error: 'Voting failed! ',
      vote0_get_more: '0 votes left, get more votes! ',
      copied: 'Web link has been copied',
      no_support_copy: 'Copy is not supported on your browser, please try to make a long press to copy'
    },
    voteLottery: {
      sign_alert: '请登录后抽奖',
      lottery_left: 'LOTTERY LEFT:',
      has_got: 'has got',
      win_tip:
        'Kuponi na zawadi za wanachama zinaweza kutazamwa Tkwangu->Kuponi yangu baada ya tukio kuisha</br>Watumiaji wanaoshinda zawadi za vitu watawasiliana nawe ili kuzichukua kwenye maduka yetu yaliyoteuliwa',
      lottery0_get_more: '没有抽奖机会了，投票获取更多抽奖机会吧！',
      win_text: '恭喜你, 获得了',
      win_vote: 'xxx票!',
      win_thanks: '很抱歉没中奖',
      win_try_again: '恭喜你, 你还有一次机会!',
      my_prize: 'My Prize',
      loading: '加载中...',
      empty_list: '你还没有中奖哦'
    },
    guidebind: {
      share: 'Share',
      ok: 'OK',
      cancel: 'Cancel',
      after_end: 'The event has ended',
      after_end_toast: 'The current event has ended. Please stay tuned to Startimes ON for more amazing discounts!',
      server_error: 'Server error!',
      btn_down: 'Download & Redeem',
      btn_sign: 'Sign In & Redeem',
      link_not_bind: 'Why Not a TV Reward? >',
      btn_not_bind: 'Redeem & Use now',
      link_bind: 'Redeem a mobile VIP >',
      btn_bind: 'Join TV PROMO',
      sign_in_content:
        '<div style="text-align: left;line-height: 20px;">For a better experience in Easter Promo, please remember to <span style="color: #ffc107;font-weight: bold;">SIGN IN</span> with your<br />1. <span style="color: #f44336;font-weight: bold;">Phone Number</span> <br />2. <span style="color: #f44336;font-weight: bold;">Smartcard Number</span> as your <span style="font-weight: bold;">password</span>. <br />Then ALL Unlimited movies&TV shows shall be available and FREE for u ONLY!</div>'
    },
    userfission: {
      share: 'SHARE',
      like: 'LIKE',
      liked: 'LIKED',
      sure: 'SURE',
      join_btn: 'JOIN NOW',
      prize_title: 'Congratultions',
      share_title: 'ACTIVITY',
      like_title: 'ACTIVITY',
      video_title: 'JOIN AND ENJOY',
      step_title: 'HOW CAN I JOIN THIS ACTIVITY',
      ok: 'OK',
      cancel: 'Cancel',
      after_end: 'Sorry, the activity has ended!',
      server_error: 'Server error! Try again later.',
      country_error: 'The activity in the current country has not started yet, please wait a little!',
      sign_tip: 'Login to partiaipate in the activity',
      has_got: 'has got',
      congratultions1: 'Congratultions!!! You have got ',
      congratultions2: 'Your friend ${0} have got ',
      for_free: ' FOR FREE',
      my_bonus_btn: 'MY BONUS DETAIL >',
      my_bonus: 'Bonus details',
      first_share: 'FIRST TIME SHARE THIS PAGE TO YOUR FRIENDS, GET /*${0} IMMEDIATELY*/',
      has_share: 'YOU HAVE GOT /*${0}*/ LIKES FROM YOUR FRIENDS',
      share_excess: 'GET MORE LIKES from YOUR FRIENDS, GET /*MORE VIP*/',
      liked_excess: 'You have helped your friends get ',
      like_excess: 'LIKE FOR your friend, GET MORE VIP',
      like_no_excess: 'Many of your friends have received benefits, hurry up and participate in the activity to get FREE STARTIMES ON ',
      like_success: 'Successful! Thanks for your action.',
      like_limit_tip: 'The opportunity to like has reached the upper limit for today, open the StarTimes ON, participate in the ACTIVITY'
    },
    unitmember: {
      error_text: 'Please enter a valid phone number.',
      placeholder: 'Phone Number',
      ok: 'OK',
      server_error: 'Server error!',
      before_start: 'Activity has not started!',
      after_end: 'Activity has ended!'
    }
  },
  clause: {
    comment: {
      title: '《Comments Guidelines》',
      desc1:
        'When you use StarTimes ON, you will be in a content-rich community of friends. The following guidelines help ensure that everyone has a fun and enjoyable StarTimes ON experience.',
      desc1:
        'When you use StarTimes ON, you will be in a content-rich community of friends. The following guidelines help ensure that everyone has a fun and enjoyable StarTimes ON experience.',
      desc2: 'If you think you\'ve seen content that violates these guidelines, click on the "flag icon".',
      subTitle1: '- Spam and Deception',
      content1:
        'Trust is the foundation on which StarTimes ON is built, and StarTimes ON does not tolerate the posting of content that is intended to deceive, mislead or defraud other users, or spam.',
      content1:
        'Trust is the foundation on which StarTimes ON is built, and StarTimes ON does not tolerate the posting of content that is intended to deceive, mislead or defraud other users, or spam.',
      subTitle2: '- Sensitive Content',
      content2:
        'We want to protect our users, especially minors. Therefore, please refrain from posting comments that jeopardize the safety of children.',
      content2:
        'We want to protect our users, especially minors. Therefore, please refrain from posting comments that jeopardize the safety of children.',
      subTitle3: '- Violent or Dangerous Content',
      content3:
        'StarTimes ON does not allow the posting of hate speech, predatory behavior, violently written content, malicious attacks, and content that promotes harmful or dangerous behavior.',
      content3:
        'StarTimes ON does not allow the posting of hate speech, predatory behavior, violently written content, malicious attacks, and content that promotes harmful or dangerous behavior.',
      subTitle4: '- Controlled Items',
      content4: 'Please do not post controlled goods for sale on StarTimes ON that violate local policies.',
      subTitle5: '- False Information',
      content5:
        'StarTimes ON does not allow the posting of certain types of misleading content or deceptive content that may pose a serious risk of extreme harm. This includes specific types of false information that could cause harm in the real world (such as the promotion of harmful remedies or cures), specific types of content that is technologically manipulated, or content that interferes with the democratic process.',
      desc3:
        "Please adhere strictly to these rules. If your behavior on or off the Platform harms our users, communities, employees, or ecosystem, we may take action based on a combination of factors, including, but not limited to, the egregiousness of the behavior and whether or not it is habitually harmful. In the case of such behavior, we may suspend your account's speaking privileges for less severe behavior, or terminate your account for more severe behavior."
    },
    screen: {
      title1: 'Screen casting usage method',
      p1:
        'Step 1: Open the StarTimes app on the projection device and confirm that the device is connected to the same Wi Fi as the phone.</br>Step 2: Click on the TV screen projection in the upper right corner of the StarTimes App player to enter the screen projection interface, and select the screen projection device that has downloaded the StarTimes App to complete the screen projection.',
      title2: 'If the screen projection device cannot be found, ',
      p2:
        'The following checks can be performed:<br/>1. The screen casting device has downloaded the StarTimes App. If it is not installed, you can open the TV/Box App Store and download the "StarTimes" App for free before casting the screen for viewing.<br/>2. The screen mirroring device is turned on and connected to the same Wi Fi as the phone.<br/>3. The device supports screen mirroring. If unable to confirm, it is recommended to consult the equipment manufacturer.<br/>4. The AP isolation and guest mode functions of the router have been turned off, and the signal amplifier network is not connected. If it has not been successfully deployed yet, you can restart network devices such as routers.<br/>5. iOS 14 or iPadOS 14 users, please confirm that local network permissions are enabled in "Settings - Privacy - Local Network - StarTimes".<br/>6. After confirming that there are no issues mentioned above, please restart the StarTimes app and try screen mirroring again.',
      title3: 'How to solve screen casting failure? ',
      p3:
        'You can try the following two solutions:<br/>1. Check if the TV/box can access the network normally.<br/>2. Has the screen casting device installed the StarTimes App? If not, you can open the TV/Box app store and download the "StarTimes" App for free before casting the screen for viewing.',
      title4: 'Stuck during screen casting',
      p4:
        '1. The current network or screen mirroring device may not support high-definition videos. It is recommended to reduce the video clarity to ensure smooth playback of the screen mirroring video.<br/>2. Can the screen mirroring device access the network normally.<br/>3. Whether the network speed of the screen projection device is stable.<br/>4. Are there any other devices in the same network that occupy a large amount of bandwidth.',
      title5: 'There are issues such as skipping episodes or inability to continue broadcasting during screen casting',
      p5: 'Suggest restarting the StarTimes app to initiate screen casting again while maintaining normal network connection.',
      title6: 'Why do some videos not support screen mirroring?',
      p6:
        'Some content is requested by the copyright owner and does not support playback in screen casting scenarios. You can choose to play this type of content directly on your mobile phone or watch it directly on your TV.',
      title7: 'How to cast the screen to the computer for viewing?',
      p7: 'Currently does not support screen mirroring on the computer side.',
      TVtitle: 'Screen casting guide',
      step1:
        '<span style="font-weight: bold;">Step 1:</span> Open the screen casting device and install the StarTimes app first, make sure the device and your mobile are connected to the same Wifi',
      step2:
        '<span style="font-weight: bold;">Step 2:</span> Click on the button "TV" at the upper right corner of your mobile app player, Select the device that has downloaded the StarTimes App to complete the screen casting.'
    }
  }
}
